<template>
  <div id="collection-bnk-account">
    <p class="img-text">
      <img src="@/assets/images/documents/heart_02.png" alt="heart" /> 서비스 제공을 위해
      <br />
      신한은행 계좌를 알려주세요
    </p>
    <p class="font--m-4 mb-4 font-weight-regular">
      통장 사본 제출하고 저렴한 수수료로 <br />
      매일 정산 받으세요!!
    </p>

    <form v-if="me && hasFile" @submit.prevent="putCollectionAccount(collection)">
      <v-text-field
        type="tel"
        v-model="collection.accountNumber"
        minlength="4"
        placeholder="계좌번호 입력"
        v-input-restrict.number
        :rules="rules.accountNumber"
      />
      <p>* ARS 인증을 위하여 <strong>1588-0559</strong>로 걸려오는 전화를 받아주세요.</p>
      <div v-if="collection.holderName">
        <p class="font-size--16 text-left mb-0">예금주</p>
        <v-text-field v-model="collection.holderName" disabled />
      </div>
      <BasicButton
        id="btn__bnkars"
        type="submit"
        class="mt-3"
        :disabled="!accountNumberIsValid || putCollectionAccountLoading"
        :loading="putCollectionAccountLoading"
      >
        {{
          me.collectionAccount &&
          me.collectionAccount.accountNumber &&
          me.collectionAccount.accountNumber.length > 1
            ? '계좌 수정하기'
            : '계좌 ARS 인증 받기'
        }}
      </BasicButton>
    </form>
    <div class="documents-items mt-10">
      <v-card class="uploader">
        <v-card-text class="pa-3">
          <DocumentFileUploader
            documentKey="bankbook"
            :label="bankbook.title"
            :originFilePath="bankbook.originPath"
            :document.sync="bankbook.file"
          >
            <template #default>
              <div class="uploader__img">
                <img src="@/assets/images/accounts/account_01.png" class="통장" />
              </div>
            </template>

            <template #activator="{ uploader, loading, disabled }">
              <div class="uploader__btn">
                <BasicButton
                  id="btn__bnkfileuploader"
                  :loading="loading"
                  :disabled="disabled"
                  :class="{
                    available: !disabled,
                    modify: !!bankbook.originPath || !!bankbook.file,
                  }"
                  @click="uploader()"
                >
                  {{ bankbook.title }}
                  <template v-if="!!bankbook.originPath || !!bankbook.file"> 수정하기 </template>

                  <template v-else> 첨부하기 </template>
                </BasicButton>
              </div>
            </template>
          </DocumentFileUploader>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { camelCaseKeys } from '@/util'

import Regex from '@/const/Regex'

export default {
  components: {
    DocumentFileUploader: () => import('@/components/documents/DocumentFileUploader.vue'),
  },
  data() {
    return {
      collection: {
        bank: 88, // 고정값
        accountNumber: null,
        holderName: null,
      },
      rules: {
        accountNumber: [
          (value) => !!value || '계좌를 입력해주세요.',
          (value) => /^\w{12,14}$/.test(value) || Regex.ACCOUNTNUMBER.MSG,
        ],
      },
      invalidMsg: {},
      putCollectionAccountLoading: false,
      accountNumberIsValid: false,
      bankbook: { title: '통장 사본', file: null, originPath: null },
      document: null,
    }
  },
  computed: {
    ...mapState('auth', ['me']),
    ...mapState('contract', { contractCurrent: 'current' }),
    hasFile() {
      return !!this.bankbook.file || !!this.bankbook.originPath
    },
    isValidAll() {
      return this.hasFile && this.accountNumberIsValid === true
    },
  },
  watch: {
    'me': {
      immediate: true,
      deep: true,
      handler(v) {
        if (v) {
          const { collectionAccount } = v
          if (!!collectionAccount?.accountNumber) {
            this.collection = {
              ...this.collection,
              ...collectionAccount,
              bank: 88,
            }
          }
        }
      },
    },
    'document': {
      immediate: true,
      deep: true,
      handler(v) {
        this.bankbook.originPath = v?.bankbook
      },
    },
    'collecton': {
      deep: true,
      handler(v) {
        this.collection.accountNumber = v.accountNumber
      },
    },
    'collection.accountNumber'(v) {
      const msg = this.getFormErrMsg('accountNumber', v)
      this.accountNumberIsValid = msg === null
    },
  },
  async created() {
    await this.getDocuments()
  },
  methods: {
    ...mapActions('auth', ['getMe']),
    ...mapActions('collectionAccount', ['updateAccount']),
    ...mapActions('document', { getStoreDocuments: 'getDocuments' }),
    ...mapActions('fundaPaygate', ['getAccountHolderName']),
    getFormErrMsg(type, newVal) {
      const rules = this.rules[type]
      let msg = null
      for (let index = 0; index < rules.length; index++) {
        const rule = rules[index]
        const isValid = rule(newVal)
        if (typeof isValid !== 'boolean') {
          msg = isValid
          break
        }
      }

      this.invalidMsg[type] = msg
      return msg
    },
    async getDocuments() {
      this.document = await this.getStoreDocuments()
    },
    async putCollectionAccount(collection) {
      try {
        this.putCollectionAccountLoading = true
        const holderName = await this.getAccountHolderName(collection)
        const { isConfirmed } = await this.$swal.basic.confirm({
          html: `예금주 : ${holderName}<br/>해당 계좌를 카드매출 입금계좌로 등록합니다.`,
        })
        if (isConfirmed === true) {
          collection.holderName = holderName
          await this.updateAccount(collection)
          await this.getMe()
          this.$emit('emitNext')
        }
      } catch (e) {
        if (e?.status === 400) {
          const { data } = e
          if (data && data.indexOf('result_message') > -1) {
            const { resultMessage } = camelCaseKeys(
              JSON.parse(data.replace(/\'/gi, '"').replace(/None/gi, 'null')),
            )
            return await this.$swal.basic.error(resultMessage)
          }
        }
        throw e
      } finally {
        this.putCollectionAccountLoading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.uploader {
  background-color: #edf9ff;

  &__img {
    width: 180px;
    text-align: center;

    margin: 0 auto;

    img {
      max-width: 180px;
      object-fit: contain;
    }
  }

  &__btn {
    text-align: center;

    margin-top: 4px;

    :deep(button) {
      width: 80% !important;
      height: 42px !important;

      &.available {
        background-color: #88d6ff !important;

        span {
          color: black !important;
        }

        &.modify {
          background-color: #fadada !important;
        }
      }
    }
  }
}

.img-text {
  display: flex;
  align-items: flex-start;

  font-size: 19px;
  font-weight: 900;

  margin-bottom: 8px;

  img {
    width: 25px;
  }
}
</style>
